import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import ComponenteError from '../../publicaciones/ComponenteError'
import * as mensajesService from '../../servicios/mensajesService'
import { buscarTodasOptimizado } from '../../servicios/publicacionesService'
import DetallePreguntas from './DetallePreguntas'
import styles from './PreguntasPublicaciones.module.css'
import Publicacion from './Publicacion'
import pubStyles from './Publicacion.module.css'

const PreguntasPublicaciones = ({ tipo }) => {
  const idUsuario = parseInt(localStorage.getItem('idUsuario'))

  const [titulo, setTitulo] = useState('')
  const [items, setItems] = useState([])
  const [sinResultados, setSinResultados] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [idsModal, setIdsModals] = useState({})
  const navigate = useNavigate()

  const fetchData = async () => {
    let filtradas = []
    if (tipo === 'comprador') {
      const { data: vendedores } = await mensajesService.buscarEnPublicaciones(idUsuario, '')
      filtradas = vendedores.flatMap((v) => v.publicaciones ?? [])
    } else {
      const { data: publicaciones } = await buscarTodasOptimizado(0, idUsuario, 0, '')
      filtradas = publicaciones.filter((pub) => pub.tieneMensaje === true)
    }
    setItems(filtradas)
    setSinResultados(filtradas.length === 0)
  }

  useEffect(() => {
    fetchData()
    setTitulo(tipo === 'comprador' ? 'Preguntas del Comprador' : 'Preguntas al Vendedor')
  }, [idUsuario, tipo])

  const onClick = (idPublicacion, idVendedor) => {
    setShowModal(true)
    setIdsModals({ idPublicacion, idVendedor })
  }

  const handleClose = () => {
    setShowModal(false)
    setIdsModals({})
  }

  const onIrAPublicacionClick = () => {
    navigate(`/publicacion/${idsModal.idPublicacion}`)
  }

  return (
    <>
      <div className={styles.container}>
        <h4 className={styles.titulo}>{titulo}</h4>
        {!sinResultados ? (
          <div className={pubStyles.lista}>
            {items.map((publicacion) => (
              <Publicacion
                key={publicacion.idPublicacion}
                onClick={onClick}
                publicacion={publicacion}
              />
            ))}
          </div>
        ) : (
          <div className="row">
            <ComponenteError tipo="I" idAviso={7} />
          </div>
        )}
      </div>

      <Modal show={showModal} onHide={handleClose} size={'lg'} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Preguntas</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <button className="btn btn-link mb-3" onClick={onIrAPublicacionClick}>
            Ir a la publicación
          </button>
          <DetallePreguntas
            idPublicacion={idsModal.idPublicacion}
            vendedorNombre={
              items.find((p) => p.idPublicacion === idsModal.idPublicacion)?.vendedorNombre
            }
            idVendedor={idsModal.idVendedor}
            tipo={tipo}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}

PreguntasPublicaciones.propTypes = {
  tipo: PropTypes.oneOf(['comprador', 'vendedor']).isRequired
}

export default PreguntasPublicaciones
